/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { observer } from "mobx-react";
import * as React from "react";

import { useCrossLocationTeamName } from "./CrossLocationTeamName.mappers";
import { CrossLocationTeamNameProps } from "./CrossLocationTeamNameProps";

/**
 * Shows the cross-location team name.
 * @param props The properties.
 * @returns The cross-location team name.
 */
export const CrossLocationTeamName: React.FC<CrossLocationTeamNameProps> = observer(function CrossLocationTeamName(
    props: CrossLocationTeamNameProps
) {
    const teamName = useCrossLocationTeamName(props);

    return <span>{teamName}</span>;
});
